/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import type { GradientMaskedImageProps } from "$src/core/components/molecules/HeroGradientMaskedImage/types";
import CustomPlatform from "$src/core/utils/platform/platform";

export default CustomPlatform.select<() => React.FC<GradientMaskedImageProps>>({
  web: () => require("./HeroGradientMaskedImage.web").default,
  default: () => require("./HeroGradientMaskedImage").default,
})();
